import { put, select } from 'redux-saga/effects'
import GlobalActions from 'store/redux/global'
import SuperAdminActions from 'store/redux/superadmin'
import Socket from 'api'
import ERROR from 'utils/errors'
import FLAG from 'utils/flags'

export function* requestMcList() {
    yield put(GlobalActions.showLoading())
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestMcList()
}

export function* handleMcList({ response }) {
    const { ok, problem, data } = response
    if (ok && data) {
        yield put(SuperAdminActions.setMcList(data))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestNewMc({ mc }) {
    yield put(GlobalActions.showLoading())
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestNewMc(mc)
}

export function* handleNewMc({ response }) {
    const { ok, problem, data } = response
    if (ok && data) {
        yield put(SuperAdminActions.addMcToList(data))
        yield put(SuperAdminActions.cleanMcTarget())
    } else if (problem === 'username_already_exists') {
        yield put(GlobalActions.error(ERROR.MC_USERNAME_COLLISION))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestUpdateMc({ mc }) {
    yield put(GlobalActions.showLoading())
    yield put(SuperAdminActions.setMcTarget(mc.uuid))
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestUpdateMc(mc)
}

export function* handleUpdateMc({ response }) {
    const { ok, problem, data } = response
    if (ok && data) {
        yield put(SuperAdminActions.updateMcAtList(data))
        yield put(SuperAdminActions.cleanMcTarget())
    } else if (problem === 'username_already_exists') {
        yield put(GlobalActions.error(ERROR.MC_USERNAME_COLLISION))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestUpdateMcPassword({ mc }) {
    yield put(GlobalActions.showLoading())
    yield put(SuperAdminActions.setMcTarget(mc.uuid))
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestUpdateMcPassword(mc)
}

export function* handleUpdateMcPassword({ response }) {
    const { ok } = response
    if (ok) {
        yield put(SuperAdminActions.cleanMcTarget())
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestDeleteMc({ uuid }) {
    yield put(GlobalActions.showLoading())
    yield put(SuperAdminActions.setMcTarget(uuid))
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestDeleteMc({ uuid })
}

export function* handleDeleteMc({ response }) {
    const { ok } = response
    if (ok) {
        const mc = yield select(state => state.superadmin.mcTarget)
        yield put(SuperAdminActions.deleteMcFromList(mc.uuid))
        yield put(SuperAdminActions.cleanMcTarget())
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestConfigFileData() {
    yield put(GlobalActions.showLoading())
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestConfigFileData()
}
export function* handleConfigFileData({ response }) {
    const { ok, problem, data } = response
    if (ok && data && data.current && data.default && data.schema) {
        yield put(SuperAdminActions.setConfigFile(data))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestUpdateConfigFile({ json }) {
    yield put(GlobalActions.setWaitingWithLoading(FLAG.SUPERADMIN_UPDATING_CONFIG_FILE))
    const emitters = Socket.emitters()
    if (emitters) emitters.superadmin.requestUpdateConfigFile(json)
}
export function* handleUpdatedConfigFile({ response }) {
    const { ok, problem, data } = response
    if (ok && data) {
        yield put(SuperAdminActions.setCurrentInConfigFile(data))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.removeWithLoading(FLAG.SUPERADMIN_UPDATING_CONFIG_FILE))
}

export function* handleServerError({ response }) {
    yield put(GlobalActions.error({
        title: response.title || 'Ooops!',
        text: response.text || 'Unknown error'
    }))
    yield put(GlobalActions.hideLoading())
}



// WEBPACK FOOTER //
// src/store/sagas/superadmin.js